import { render, staticRenderFns } from "./formDadosExtras.vue?vue&type=template&id=b3e89b76"
import script from "./formDadosExtras.vue?vue&type=script&lang=js"
export * from "./formDadosExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports